import React, { useRef } from 'react'
import { useInfo } from '../../context/useInfo'
import Login from '../Login';
import NoPermissions from '../NoPermissions';
import { Outlet } from 'react-router';

function DasboardLayout() {
  const { info } = useInfo();

  if (info == null) return <Login />
  if (info.badges.find((badge: any) => badge == 4) == null) return <NoPermissions />

  return <Outlet />
}

export default DasboardLayout